<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <paginated-table :id="$attrs['id']"
                   :items-per-page="itemsPerPage"
                   :rows="sortedFolios"
                   columns="8"
                   grid-template-columns="max-content repeat(calc(var(--table-columns) - 1), auto)"
                   min-width="700px">
    <template slot="table-head">
      <div class="hm-table__th">&nbsp;</div>
      <div class="hm-table__th">{{ $t('table.folioTable.folioNumber') }}</div>
      <div class="hm-table__th">{{ $t('table.folioTable.folioType') }}</div>
      <div class="hm-table__th">{{ $t('table.folioTable.invoiceNumber') }}</div>
      <div class="hm-table__th">{{ $t('table.folioTable.invoiceRecipient') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.folioTable.charges') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.folioTable.payments') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.folioTable.balance') }}</div>
    </template>
    <template v-slot:default="slotProps">
      <template v-for="folio in slotProps.currentPage">
        <div v-if="(folio.hasAnyTransactions === true && folio.status !== 'Final') || folio.balance !== 0" class="hm-table__td" @click="routeToFolio(folio)"><i class="fal fa-exclamation-triangle fa-w-14 color--warn"></i></div>
        <div v-else-if="folio.status === 'Final' && folio.balance === 0" class="hm-table__td" @click="routeToFolio(folio)"><i class="fal fa-check color--mint"></i></div>
        <div v-else-if="folio.noPost && isEmpty(folio.invoiceNumber)" class="hm-table__td" @click="routeToFolio(folio)"><i class="fal fa-lock color--gray"></i></div>
        <div v-else class="hm-table__td" @click="routeToFolio(folio)"></div>
        <div class="hm-table__td" @click="routeToFolio(folio)">{{ folio.number + 1 }}</div>
        <div class="hm-table__td" @click="routeToFolio(folio)">{{ $t('table.folioTable.folioType_folio') }}</div>
        <div v-if="folio.noPost && isEmpty(folio.invoiceNumber)" class="hm-table__td" @click="routeToFolio(folio)">{{ folio.historicalInvoiceNumbers | toList }}</div>
        <div v-else class="hm-table__td" @click="routeToFolio(folio)">{{ folio.invoiceNumber }}</div>
        <div class="hm-table__td privacy--blur" @click="routeToFolio(folio)">{{ folio.address }}</div>
        <div class="hm-table__td text-right" @click="routeToFolio(folio)">{{ folio.chargeAmount | toCurrency }} {{ hotelSettings.details.currency }}</div>
        <div class="hm-table__td text-right" @click="routeToFolio(folio)">{{ folio.paymentAmount | toCurrency }} {{ hotelSettings.details.currency }}</div>
        <div :class="[{'color--red': folio.balance < 0}]" class="hm-table__td text-right" @click="routeToFolio(folio)">{{ folio.balance | toCurrency }} {{ hotelSettings.details.currency }}</div>
      </template>
    </template>
  </paginated-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last, sumBy, isString } from 'lodash';
import PaginatedTable from './PaginatedTable';

export default {
  name: 'FolioTable',
  components: { PaginatedTable },
  mixins: [HotelmeisterMixin],

  props: {
    folios: {
      type: Array,
      required: true,
      default: () => [],
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10,
    },
  },

  data: function () {
    return {
    };
  },

  computed: {
    sortedFolios: function () {
      return sortBy(
        this.folios,
        [
          o => (((o.hasAnyTransactions === true && o.status !== 'Final') || o.balance !== 0) ? 1 : 100),
          'number',
        ],
      );
    },
  },

  methods: {
    routeToFolio(folio) {
      const folioId = folio.id;

      if ((isEmpty(folio.parentId) || !isString(folio.parentId)) || isEmpty(folio.ClassName)) {
        this.$router.push({
          name: `${this.$route.meta.parent}Folio`,
          params: this.routeParams(folioId),
        });
      } else {
        let routeName = null;
        switch (folio.ClassName) {
          case 'RoomReservationFolios':
            routeName = 'reservationFolio';
            break;
          case 'GuestProfileFolios':
            routeName = 'guestFolio';
            break;
          default:
            routeName = null;
            break;
        }

        if (!isEmpty(routeName)) {
          this.$router.push({
            name: routeName,
            params: {
              hotelId: this.$route.params.hotelId,
              guestProfileId: folio.parentId,
              reservationId: folio.parentId,
              folioId: folioId,
            },
          });
        }
      }
    },
    routeParams(folioId) {
      const ret = cloneDeep(this.$route.params);
      ret.folioId = folioId;
      return ret;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/FolioTable.vue